import UppbeatCredit from '@/components/Icons/UppbeatCredit';
import { useSettings } from '@/hooks/state/useSettings';
export const RemainingCredits = () => {
  const {
    settings
  } = useSettings();
  const remainingCredits = settings?.credits.credits_current;
  return <div className="flex flex-row gap-2 leading-none" data-sentry-component="RemainingCredits" data-sentry-source-file="RemainingCredits.tsx">
      <UppbeatCredit className="aspect-square size-8" data-sentry-element="UppbeatCredit" data-sentry-source-file="RemainingCredits.tsx" />
      <div className="flex flex-col gap-1">
        <div className="flex flex-col text-xs xl:text-sm dark:text-white">
          <span className="font-semibold">
            {remainingCredits} free{' '}
            {remainingCredits === 1 ? 'download' : 'downloads'}
          </span>
          <span> remaining this month</span>
        </div>
      </div>
    </div>;
};